import { z } from 'zod';
import { TRIAL_VISIT_TYPES } from '../trials/trials.schema.js';
// ---------------------------------------------------------------------------
// Registering the performed side of a visit (Domain 4 — Cockpit, REQ-VIS-020…028)
// ---------------------------------------------------------------------------
/** `HH:MM`, the shape the cockpit shows and `PatientVisitDto` carries. */
const PerformedTimeSchema = z
    .string()
    .regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'Godzina musi być w formacie GG:MM (HH:MM)');
/**
 * Body of `PATCH /api/v1/visits/:visitId/registration` — the PERFORMED side of
 * ONE patient visit (REQ-VIS-020 date + optional hour, REQ-VIS-025 type,
 * REQ-VIS-026 main comment).
 *
 * `date` is a CALENDAR DAY (`z.iso.date()`), not an instant — the column is
 * `date` and the whole cockpit reasons in days. It is the registration marker
 * (REQ-VIS-035), so `null` is meaningful: it UNDOES the registration
 * (REQ-VIS-028), which is why the field is nullable rather than optional.
 * An OMITTED `date` is a 400 — "no date" is a deliberate act, not an accident.
 *
 * `time` is optional and nullable: a visit without a performed hour is normal
 * (phone visits, REQ-VIS-020), and an empty one stays empty — it never becomes
 * midnight.
 *
 * `type` is the contact channel ACTUALLY used (REQ-VIS-025: a site visit may
 * have happened by phone). Optional, because a caller may register the date
 * alone and keep the type the catalog planned; when omitted the stored value
 * is left untouched.
 *
 * `mainComment` (REQ-VIS-026) is optional and nullable: an empty comment is
 * allowed, and `null` clears it. This is NOT the reason for an out-of-window
 * visit — REQ-VIS-024 is deliberately out of scope for this endpoint.
 */
export const RegisterVisitRequestSchema = z.object({
    date: z.iso.date().nullable(),
    time: PerformedTimeSchema.nullable().optional(),
    type: z.enum(Object.values(TRIAL_VISIT_TYPES)).optional(),
    mainComment: z.string().max(2000).nullable().optional(),
});
//# sourceMappingURL=register-visit.schema.js.map